import { gql } from 'graphql-request'

export const TypedLotsListGql = gql`
  query getTypedWoolLots(
    $currentPage: Int!
    $pageSize: Int!
    $orderBy: ListTypedWoolLotsOrderByOptions!
    $orderByAscending: Boolean!
    $from: DateTime
    $to: DateTime
  ) {
    listTypedWoolLots(
      request: {
        currentPage: $currentPage
        pageSize: $pageSize
        orderByAscending: $orderByAscending
        orderBy: $orderBy
        from: $from
        to: $to
      }
    ) {
      currentPage
      totalPageCount
      totalResultCount
      results {
        purchaseBrand
        stationRecordNumber
        saleNumber
        season
        code
        bales
        internalReferenceCode
        typeCurrent
        internalComment
        lastTyped
        actions
      }
    }
  }
`
